import Link from "next/link";
import React from "react";

const TermsAndConditionsContentStatic = () => {
  return (
    <div className="flex-1 space-y-4">
      <div>
        <div className="font-bold text-2xl">UNIVERSAL TERMS</div>
      </div>
      <div>
        <div>(v2.0.0 dated 30.09.2022)</div>
      </div>
      <div>
        <div>YOUR RELATIONSHIP WITH QURE</div>
      </div>
      <div>
        <div>
          Your use of Qure’s products, software&nbsp;(including but not limited to any and
          all versions, forms or&nbsp; renditions of qXR, qER, qCT-Lung, qVH, qMSK
          qTrack), applications such as the QureApp and its website equivalent i.e.&nbsp;
          <a href="https://app.qure.ai/">https://app.qure.ai/</a>, services, Devices and
          Website (referred to collectively as the “Services”) excluding any services
          provided to You (“You” or “Your” or “Customer”) by Qure under a separate written
          agreement,&nbsp;is subject to the terms of a legal agreement&nbsp;between You
          and Qure. “Qure” or “Us” or “We” or “Our” means Qure.ai Technologies Private
          Limited, a company registered under the laws of India, having its registered
          office at 7th Floor, Oberoi Commerz-II, International, Business Park, Oberoi
          Garden City, Off Western, Express Highway, Goregaon East, Mumbai, Maharashtra,
          400063, India and any of its subsidiaries and affiliates.
        </div>
      </div>
      <div>
        <div>
          The Terms here explain the legal agreement between You and Qure and sets out the
          Universal Terms.
        </div>
      </div>
      <div>
        <div>
          Unless otherwise agreed in writing with Qure, Your legal agreement with Qure
          will always include, at a minimum, the terms and conditions as set out
          hereinbelow and under&nbsp;
          <a href="https://qure.ai/legal/#acceptable-use-policy:~:text=Legal%20Disclaimer-,Acceptable%20Use%20Policy,-Acceptable%20Use%20Policy">
            Acceptable Use Policy
          </a>
          . These are referred as the “Universal Terms”. We reserve the right to modify
          and amend these Universal Terms from time to time at Our sole discretion, in
          which case the new Universal Terms will supersede prior versions of the
          Universal Terms. We shall post the modified or amended version of these
          Universal Terms in this section of the Website. By using Our Services after the
          changes/modifications have been posted, You agree to automatically accept those
          changes/modifications and it shall be deemed conclusively that You have agreed
          to comply with and be bound by all terms and conditions of the modified version
          of Universal Terms thereafter.
        </div>
      </div>
      <div>
        <div>
          Your agreement with Qure will also include the terms of any agreed terms in
          writing or otherwise applicable to the Services, in addition to the Universal
          Terms. All of these are referred to as the “Additional Terms”. Where Additional
          Terms apply to a Service, these will be accessible for You to read either
          within, or through Your use of, that Service or would be under a separate
          written agreement with You.
        </div>
      </div>
      <div>
        <div>
          The Universal Terms, together with the Additional Terms, if any, (collectively
          referred to as “Terms”), form a legally binding agreement between You and Qure
          in relation to Your use of the Services. It is important that You take the time
          to read them carefully.
        </div>
      </div>
      <div>
        <div>
          If there is any contradiction between the Additional Terms and the Universal
          Terms, then the Additional Terms shall take precedence in relation to that
          Service.
        </div>
      </div>
      <div>
        <div>ACCEPTING THE TERMS</div>
      </div>
      <div>
        <div>
          In order to use the Services, You must first agree to the Terms. You shall not
          use the Services if You do not accept the Terms.
        </div>
      </div>
      <div>
        <div>You can accept the Terms by:</div>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            clicking accept or agree to the Terms, where this option is made available to
            You by Qure in the user interface for any Service; or
          </li>
          <li>
            by actually using the Services. In this case, You understand and agree that
            Qure will treat Your use of the Services in any manner whatsoever (including
            without limitation to login into or accessing Our Services or installing
            Services on any devices) as acceptance of the Terms from that point onwards.
          </li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            By accepting the Terms in writing under a written agreement between You and
            Qure.
          </li>
        </ul>
      </div>
      <div>
        <div>
          You shall not use the Services and shall not accept the Terms if (a) You are not
          of legal age to enter into and form a legally binding contract with Qure, or (b)
          in the event You are entering into these Terms on behalf of any entity/company
          or its group or affiliates, You do not possess the requisite authority to bind
          such entities, company, or its groups and affiliates to these Terms, or (c) You
          are a person barred from receiving the Services or entering into binding legal
          contract under the laws of India or other countries including the country in
          which You are resident or from where You intend to use the Services.
        </div>
      </div>
      <div>
        <div>
          Before You continue, You should print or save a local copy of the Universal
          Terms for Your records.
        </div>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>DEFINITIONS</li>
        </ul>
      </div>
      <div>
        <div>
          “Data” means any and all information and materials, including without
          limitation, Data of Users and End Users, submitted to the Services by You
          through Your Account or any data provided by You / Customer to Qure in
          connection with Your / Customer’s use of the Services. Data that shall be
          provided to Qure shall be used for processing and aggregated de-identified Data
          may be used for testing, improvement and development of the Services. Further,
          the outputs of the usage of the Data with the Services may be used for
          publications including in peer reviewed journals and for academic/research
          purposes.
        </div>
      </div>
      <div>
        <div>
          “Devices” means laptops, desktops, mobile phones, any electronic device capable
          of using Qure’s proprietary software or any other device which contains Qure’s
          proprietary software provided by Qure to the Customer. Qure shall have a right
          to access the Devices periodically to check on the number of scans processed as
          well as for routine maintenance.&nbsp;We shall have a right to remove the Qure’s
          software from the Devices and the Customer shall be obligated to return the
          Devices to its factory settings, free from Qure’s software and Our intellectual
          property. Further, the Customer shall be obligated to return the Devices to Us
          within 30 days from date of such demand as and when raised by Us.
        </div>
      </div>
      <div>
        <div>“Eligible Data”&nbsp;means the following:</div>
      </div>
      <div>
        <div className="table-auto md:hidden">
          <div className="p-4">
            <div className="border border-gray-700">
              <div className="px-3 py-3 font-semibold">
                <div className="text-sm">X-Ray Specifications</div>
              </div>
              <div className="px-3 py-3 font-semibold">
                <div className="text-sm">CT Scans Specifications</div>
              </div>
            </div>
            <div className="border border-gray-700">
              <div className="px-3 py-3">
                <div className="text-sm">
                  Inclusion Criteria:&nbsp;1. Patient Age: 6 years and above2. Modality:
                  CR/DR/DX3. Study Description: Chest X-ray4. Body Part Examined: Chest5.
                  Image View: AP/PA6. Image Format: DICOM (.dcm)7. Image Resolution:
                  Minimum of 1440×1440Exclusion Criteria:1. Lateral X-rays2. X-rays that
                  do not contain the entire lung field3. X-rays of other body parts4.
                  X-rays of patients below 6 years of age
                </div>
              </div>
              <div className="px-3 py-3">
                <div className="text-sm">
                  Inclusion Criteria:1. Non-contrast axial CT scan series with
                  consistently spaced axial slices2. Soft reconstruction kernel covering
                  the complete brain3. Maximum slice thickness of 6mm4. Age is more than
                  18 yearsExclusion Criteria:1. Scans with obvious postoperative defects,
                  or from patients who previously underwent brain surgery2. Scans with
                  artifacts such as burr holes, shunts or clips3. Scans containing metal
                  artifacts4. Scans containing excessive motion artifacts5. Scans
                  containing improperly ordered slices6. Series containing missing slices
                </div>
              </div>
            </div>
          </div>
        </div>
        <table className="hidden table-auto md:block">
          <tbody className="p-4">
            <tr className="border border-gray-700">
              <td className="border border-gray-700 px-3 py-3 font-semibold">
                <div className="text-sm">X-Ray Specifications</div>
              </td>
              <td className="border border-gray-700 px-3 py-3 font-semibold">
                <div className="text-sm">CT Scans Specifications</div>
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border border-gray-700 px-3 py-3">
                <div className="text-sm">
                  Inclusion Criteria:&nbsp;1. Patient Age: 6 years and above2. Modality:
                  CR/DR/DX3. Study Description: Chest X-ray4. Body Part Examined: Chest5.
                  Image View: AP/PA6. Image Format: DICOM (.dcm)7. Image Resolution:
                  Minimum of 1440×1440Exclusion Criteria:1. Lateral X-rays2. X-rays that
                  do not contain the entire lung field3. X-rays of other body parts4.
                  X-rays of patients below 6 years of age
                </div>
              </td>
              <td className="border border-gray-700 px-3 py-3">
                <div className="text-sm">
                  Inclusion Criteria:1. Non-contrast axial CT scan series with
                  consistently spaced axial slices2. Soft reconstruction kernel covering
                  the complete brain3. Maximum slice thickness of 6mm4. Age is more than
                  18 yearsExclusion Criteria:1. Scans with obvious postoperative defects,
                  or from patients who previously underwent brain surgery2. Scans with
                  artifacts such as burr holes, shunts or clips3. Scans containing metal
                  artifacts4. Scans containing excessive motion artifacts5. Scans
                  containing improperly ordered slices6. Series containing missing slices
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <div>
          “End User”&nbsp;means any person or entity other than You or Your Users with
          whom You interact using the Services.
        </div>
      </div>
      <div>
        <div>
          “Personal Data”&nbsp;means information relating to an identified or identifiable
          natural person that is submitted by You to the Services as part of Data.
          Identified or identifiable natural person is one who can be identified, directly
          or indirectly, in particular by reference to an identifier such as a name, an
          identification number, location data, an online identifier or to one or more
          factors specific to the physical, physiological, genetic, mental, economic,
          cultural or social identity of that natural person.
        </div>
      </div>
      <div>
        <div>
          “Process”&nbsp;means any operation or set of operations which is performed on
          Data or on sets of Data, whether or not by automated means, such as collection,
          recording, organisation, structuring, storage, adaptation or alteration,
          retrieval, consultation, use, disclosure by transmission, dissemination or
          otherwise making available, alignment or combination, restriction, erasure or
          destruction.
        </div>
      </div>
      <div>
        <div>
          “User”&nbsp;means a designated user within the Services, including an account
          administrator, employee, shareholder, auditor, lawyer, founder and other
          designated users
        </div>
      </div>
      <div>
        <div>
          “Website” means&nbsp;<a href="http://www.qure.ai/">www.qure.ai</a>.
        </div>
      </div>
      <div>
        <div>2. YOUR / CUSTOMER’S ROLE AND OBLIGATIONS&nbsp;</div>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            You shall be solely responsible for receiving all explicit or implicit
            consents, as required under applicable laws, from the patients, Users or
            similar Data owners and having accepted these Universal Terms, it will be
            deemed that such consents have been duly received by You and will be available
            upon request for Us to audit.The responsibility of de-identification and
            anonymization of the Data shall solely vest with You and the Data shall be
            de-identified and anonymized by You before being processed on Our Services.
            Any Data that is processed by You on Our Services shall be presumed to be
            de-identified or anonymized by You as required under applicable laws. To the
            maximum extent permitted under applicable laws, Qure is neither responsible
            for nor does Qure undertakes any lability whatsoever arising from You
            processing any Personal Data on Our Services.You undertake and represent that
            You are well aware that (i) the Qure’s Services are supportive medical image
            analysis tools which support radiologists in the radiology diagnostic process
            by identifying some abnormalities which may be present in the medical image;
            (ii) Qure’s Services are intended solely for investigational purposes and is
            not intended for primary diagnosis; (iii) Qure’s Services are intended for use
            only by appropriately qualified and trained medical personnel, which are board
            certified radiologists with a valid license to practice; and (iv) Qure’s
            Services are intended for use only as a supplement to standard methods of
            interpreting radiological images. Qure’s Services should not be exclusively
            relied upon for arriving at a diagnosis, treatment plan, or other decision
            that may affect patient care. It is clarified that use of Qure’s Services
            shall not result in any change in clinical protocol, patient management
            policies, etc. that may be maintained by You.Qure or any other person or party
            that contributed to this Services makes no representations or warranties in
            relation to the medical information in these Terms. Reliance on any
            information provided by the Services or any linked websites is solely at Your
            own risk. Qure specifically disclaims all responsibility for any liability,
            loss, or risk, personal or otherwise, which is incurred as a consequence,
            directly or indirectly, of the use of the Services or the application of any
            content contained or referenced therein.The ultimate judgment regarding the
            propriety of any specific medical treatment must be made by the expert medical
            physician and the patient in light of all the circumstances presented by the
            individual patient, and the known variability and biological behaviour of the
            disease.
          </li>
          <li>
            You shall be solely responsible for receiving all explicit or implicit
            consents, as required under applicable laws, from the patients, Users or
            similar Data owners and having accepted these Universal Terms, it will be
            deemed that such consents have been duly received by You and will be available
            upon request for Us to audit.The responsibility of de-identification and
            anonymization of the Data shall solely vest with You and the Data shall be
            de-identified and anonymized by You before being processed on Our Services.
            Any Data that is processed by You on Our Services shall be presumed to be
            de-identified or anonymized by You as required under applicable laws. To the
            maximum extent permitted under applicable laws, Qure is neither responsible
            for nor does Qure undertakes any lability whatsoever arising from You
            processing any Personal Data on Our Services.You undertake and represent that
            You are well aware that (i) the Qure’s Services are supportive medical image
            analysis tools which support radiologists in the radiology diagnostic process
            by identifying some abnormalities which may be present in the medical image;
            (ii) Qure’s Services are intended solely for investigational purposes and is
            not intended for primary diagnosis; (iii) Qure’s Services are intended for use
            only by appropriately qualified and trained medical personnel, which are board
            certified radiologists with a valid license to practice; and (iv) Qure’s
            Services are intended for use only as a supplement to standard methods of
            interpreting radiological images. Qure’s Services should not be exclusively
            relied upon for arriving at a diagnosis, treatment plan, or other decision
            that may affect patient care. It is clarified that use of Qure’s Services
            shall not result in any change in clinical protocol, patient management
            policies, etc. that may be maintained by You.Qure or any other person or party
            that contributed to this Services makes no representations or warranties in
            relation to the medical information in these Terms. Reliance on any
            information provided by the Services or any linked websites is solely at Your
            own risk. Qure specifically disclaims all responsibility for any liability,
            loss, or risk, personal or otherwise, which is incurred as a consequence,
            directly or indirectly, of the use of the Services or the application of any
            content contained or referenced therein.The ultimate judgment regarding the
            propriety of any specific medical treatment must be made by the expert medical
            physician and the patient in light of all the circumstances presented by the
            individual patient, and the known variability and biological behaviour of the
            disease.
          </li>
          <li>
            You shall be solely responsible for receiving all explicit or implicit
            consents, as required under applicable laws, from the patients, Users or
            similar Data owners and having accepted these Universal Terms, it will be
            deemed that such consents have been duly received by You and will be available
            upon request for Us to audit.
          </li>
          <li>
            The responsibility of de-identification and anonymization of the Data shall
            solely vest with You and the Data shall be de-identified and anonymized by You
            before being processed on Our Services. Any Data that is processed by You on
            Our Services shall be presumed to be de-identified or anonymized by You as
            required under applicable laws. To the maximum extent permitted under
            applicable laws, Qure is neither responsible for nor does Qure undertakes any
            lability whatsoever arising from You processing any Personal Data on Our
            Services.
          </li>
          <li>
            You undertake and represent that You are well aware that (i) the Qure’s
            Services are supportive medical image analysis tools which support
            radiologists in the radiology diagnostic process by identifying some
            abnormalities which may be present in the medical image; (ii) Qure’s Services
            are intended solely for investigational purposes and is not intended for
            primary diagnosis; (iii) Qure’s Services are intended for use only by
            appropriately qualified and trained medical personnel, which are board
            certified radiologists with a valid license to practice; and (iv) Qure’s
            Services are intended for use only as a supplement to standard methods of
            interpreting radiological images. Qure’s Services should not be exclusively
            relied upon for arriving at a diagnosis, treatment plan, or other decision
            that may affect patient care. It is clarified that use of Qure’s Services
            shall not result in any change in clinical protocol, patient management
            policies, etc. that may be maintained by You.
          </li>
          <li>
            Qure or any other person or party that contributed to this Services makes no
            representations or warranties in relation to the medical information in these
            Terms. Reliance on any information provided by the Services or any linked
            websites is solely at Your own risk. Qure specifically disclaims all
            responsibility for any liability, loss, or risk, personal or otherwise, which
            is incurred as a consequence, directly or indirectly, of the use of the
            Services or the application of any content contained or referenced therein.
          </li>
          <li>
            The ultimate judgment regarding the propriety of any specific medical
            treatment must be made by the expert medical physician and the patient in
            light of all the circumstances presented by the individual patient, and the
            known variability and biological behaviour of the disease.
          </li>
        </ul>
      </div>
      <div>
        <div>3. YOUR / CUSTOMER’S REPRESENTATIONS AND WARRANTIES&nbsp;</div>
      </div>
      <div>
        <div>i. YOU REPRESENT AND WARRANT THAT YOU SHALL NOT:</div>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            license, sublicense, sell, resell, rent, lease, transfer, assign, distribute,
            time share or otherwise commercially exploit or make the Services available to
            any third-party, other than Users in furtherance of Your internal business
            purposes and as expressly permitted by these Universal Terms or Additional
            Terms;modify, adapt, re-engineer, replicate, or hack the Services or otherwise
            attempt to gain or gain unauthorized access to the Services or related systems
            or networks;use the Services to Process any Personal Data;violate any law or
            regulation, including, without limitation, any applicable export control laws,
            privacy laws or any other purpose not reasonably intended by Qure;use the
            Services to store or process any content that infringes upon any person’s
            intellectual property rights or is unlawful, racist, hateful, abusive,
            libelous, obscene, or discriminatory; or“crawl,” “scrape,” or “spider” any
            page, data, or portion of or relating to the Services (through use of manual
            or automated means).
          </li>
          <li>
            license, sublicense, sell, resell, rent, lease, transfer, assign, distribute,
            time share or otherwise commercially exploit or make the Services available to
            any third-party, other than Users in furtherance of Your internal business
            purposes and as expressly permitted by these Universal Terms or Additional
            Terms;
          </li>
          <li>
            modify, adapt, re-engineer, replicate, or hack the Services or otherwise
            attempt to gain or gain unauthorized access to the Services or related systems
            or networks;
          </li>
          <li>use the Services to Process any Personal Data;</li>
          <li>
            violate any law or regulation, including, without limitation, any applicable
            export control laws, privacy laws or any other purpose not reasonably intended
            by Qure;
          </li>
          <li>
            use the Services to store or process any content that infringes upon any
            person’s intellectual property rights or is unlawful, racist, hateful,
            abusive, libelous, obscene, or discriminatory; or
          </li>
          <li>
            “crawl,” “scrape,” or “spider” any page, data, or portion of or relating to
            the Services (through use of manual or automated means).
          </li>
        </ul>
      </div>
      <div>
        <div>
          ii. You represent and warrant that the electronic Devices, systems and any other
          hardware or cloud computing provided or used by You for availing the Services
          are free from:
        </div>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            all viruses known in the software industry at the time of its implementation
            and that could have been detected by the use of the latest commercially
            available virus detection software;all forms of electronic repossessions and
            logic bombs as far as those logic bombs could have been avoided by You; andall
            forms of disabling codes, applications or software that may affect the proper
            operation of the Services, howsoever placed or manifested.
          </li>
          <li>
            all viruses known in the software industry at the time of its implementation
            and that could have been detected by the use of the latest commercially
            available virus detection software;
          </li>
          <li>
            all forms of electronic repossessions and logic bombs as far as those logic
            bombs could have been avoided by You; and
          </li>
          <li>
            all forms of disabling codes, applications or software that may affect the
            proper operation of the Services, howsoever placed or manifested.
          </li>
        </ul>
      </div>
      <div>
        <div>
          iii. You further represent and warrant that You shall take all necessary steps
          to ensure all Your Devices are, up-to-date at all times and possessing the
          required capabilities to detect and tackle all new forms of viruses, as may be
          detectable by the use of the latest commercially available virus detection
          software(s).
        </div>
      </div>
      <div>
        <div>
          iv. You represent and warrant that You, Your affiliates, owners, directors,
          officers, employees and agents will not at any time offer, promise, pay or
          arrange for payment or indulge in giving of a bribe or any benefit, advantage or
          anything of value to any public official, individual, entity or any other third
          party in exchange for an improper advantage in any form either directly or
          indirectly. You further represent and warrant that You, Your affiliates, owners,
          directors, officers, employees and agents will act in full compliance with any
          applicable anti-corruption laws and regulations, industry and professional codes
          including the&nbsp;
          <a href="https://en.wikipedia.org/wiki/Prevention_of_Corruption_Act,_1988">
            Prevention of Corruption Act, 1988
          </a>
          , FCPA, UK Bribery Act, and any other international or local legislation on the
          subject matter. You shall ensure and always maintain appropriate records as per
          standard industrial practices with respect to billing, accounting and other
          internal controls to ensure compliance with international and other applicable
          anti-bribery and anti-corruption laws.
        </div>
      </div>
      <div>
        <div>4. USE OF QURE’S PRODUCTS, SOFTWARE, QUREAPP AND DEVICES</div>
      </div>
      <div>
        <div>
          You acknowledge that the use of Qure’s products, software, applications
          including the QureApp and Devices will at all times be pursuant to and only as
          detailed in the User manual provided along with the Qure’s products, software,
          applications and Devices and as per the terms and conditions contained in Qure’s
          products, software, applications such as the QureApp and Devices. We may update
          the User manual and the terms and conditions periodically. We undertake to
          provide, at Our sole discretion, all necessary support to You in case such an
          update is done and a requirement for Your identified personnel is deemed fit.
        </div>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>UPDATE OF SOFTWARE</li>
        </ul>
      </div>
      <div>
        <div>
          We may update the Qure’s products, software, applications such as the Qure App
          and Devices (“Update”) anytime. However, in case the Update is not accepted, We
          shall not be responsible for any malfunction in Qure’s product, software and
          Device, that could have been reasonably rectified through such Update. You
          shall, within a period of five (5) business days from the Update, report any
          issues with the Update to us. Upgrades to the Qure’s product, software, Qure App
          and Devices, which include but are not limited to new features or new findings,
          shall be provided at an additional cost. It is clarified that providing Updates
          and upgrades for any offline deployment of Qure’s software via Devices or for
          any on premise deployment shall be at sole discretion of Qure.
        </div>
      </div>
      <div>
        <div>
          Qure does not promise that it will always Update the Services (including mobile
          applications like QureApp) so that it is relevant to You and/or works with the
          Android &amp; iOS versions that You have installed on Your Device. However, You
          promise to always accept Updates to the Services when offered to You, We may
          also wish to stop providing the Services, and may terminate use of it at any
          time without giving notice of termination to You. Unless we tell You otherwise,
          upon any termination, (a) the rights and licenses granted to You in these terms
          will end; (b) You must stop using the Services, and (if needed) delete it from
          Your Device.
        </div>
      </div>
      <div>
        <div>
          Like all forms of online information, the content and quality of these Services
          may change over time. It is the primary responsibility of the User to use their
          individual judgment and to consult with their health care professional to ensure
          that Services are appropriate for their treatment.
        </div>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>PAYMENT TERMS</li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            Each payment or deposit to be made by You to Qure for use of Services shall be
            made by way of direct transfer into current account of Qure as per details
            provided by Qure in writing. Customer shall forthwith provide Qure the proof
            of payment made by way of direct transfer.Each payment and deposit to be made
            by You to Qure shall be made without set-off or counterclaim and free and
            clear of and without any deduction or withholding of any kind whatsoever. If
            You deduct income tax at source or withholding tax, if applicable from the
            payments to be made to Qure hereunder, You shall do so at rates applicable to
            Qure and shall issue TDS certificates to Qure forthwith.In the event of any
            failure or delay by You to pay or deposit any amount on or before the due
            dates as required under the Services, You shall pay Qure interest at the rate
            of 1.5% (one point five per cent) per month on the amount delayed, for the
            period of such delay. Payment of such interest shall be without prejudice to
            Qure’s other rights and remedies under law or otherwise.All costs and
            expenditures arising from payment and deposit to be made to Qure by You,
            including without limitation,&nbsp;the wire transfer charges, transaction
            fees, etc. shall be solely borne by You. IMPORTANT: You must inform Your bank/
            financial payment partner that “Sender pays all fees" to ensure that the full
            invoice amount is received by Qure.Any costs, fees, expenses or disbursements
            incurred by the Qure in recovering any monies payable by the Customer to Qure,
            including dishonoured cheques, failed wire transfers, debt collection agency
            fees, legal costs and interest thereon shall be paid by the Customer on a full
            indemnity basis.You shall submit a payment advice detailing the invoice(s)
            against which each payment is made along with the details of TDS, if any,
            simultaneously with the payment. Such payment advice along with a soft copy of
            the TDS certificate shall be submitted to email id&nbsp;
            <a href="mailto:finance@qure.ai">finance@qure.ai</a>&nbsp;. The format of
            payment advice is as below:
          </li>
          <li>
            Each payment or deposit to be made by You to Qure for use of Services shall be
            made by way of direct transfer into current account of Qure as per details
            provided by Qure in writing. Customer shall forthwith provide Qure the proof
            of payment made by way of direct transfer.Each payment and deposit to be made
            by You to Qure shall be made without set-off or counterclaim and free and
            clear of and without any deduction or withholding of any kind whatsoever. If
            You deduct income tax at source or withholding tax, if applicable from the
            payments to be made to Qure hereunder, You shall do so at rates applicable to
            Qure and shall issue TDS certificates to Qure forthwith.In the event of any
            failure or delay by You to pay or deposit any amount on or before the due
            dates as required under the Services, You shall pay Qure interest at the rate
            of 1.5% (one point five per cent) per month on the amount delayed, for the
            period of such delay. Payment of such interest shall be without prejudice to
            Qure’s other rights and remedies under law or otherwise.All costs and
            expenditures arising from payment and deposit to be made to Qure by You,
            including without limitation,&nbsp;the wire transfer charges, transaction
            fees, etc. shall be solely borne by You. IMPORTANT: You must inform Your bank/
            financial payment partner that “Sender pays all fees" to ensure that the full
            invoice amount is received by Qure.Any costs, fees, expenses or disbursements
            incurred by the Qure in recovering any monies payable by the Customer to Qure,
            including dishonoured cheques, failed wire transfers, debt collection agency
            fees, legal costs and interest thereon shall be paid by the Customer on a full
            indemnity basis.You shall submit a payment advice detailing the invoice(s)
            against which each payment is made along with the details of TDS, if any,
            simultaneously with the payment. Such payment advice along with a soft copy of
            the TDS certificate shall be submitted to email id&nbsp;
            <a href="mailto:finance@qure.ai">finance@qure.ai</a>&nbsp;. The format of
            payment advice is as below:
          </li>
          <li>
            Each payment or deposit to be made by You to Qure for use of Services shall be
            made by way of direct transfer into current account of Qure as per details
            provided by Qure in writing. Customer shall forthwith provide Qure the proof
            of payment made by way of direct transfer.
          </li>
          <li>
            Each payment and deposit to be made by You to Qure shall be made without
            set-off or counterclaim and free and clear of and without any deduction or
            withholding of any kind whatsoever. If You deduct income tax at source or
            withholding tax, if applicable from the payments to be made to Qure hereunder,
            You shall do so at rates applicable to Qure and shall issue TDS certificates
            to Qure forthwith.
          </li>
          <li>
            In the event of any failure or delay by You to pay or deposit any amount on or
            before the due dates as required under the Services, You shall pay Qure
            interest at the rate of 1.5% (one point five per cent) per month on the amount
            delayed, for the period of such delay. Payment of such interest shall be
            without prejudice to Qure’s other rights and remedies under law or otherwise.
          </li>
          <li>
            All costs and expenditures arising from payment and deposit to be made to Qure
            by You, including without limitation,&nbsp;the wire transfer charges,
            transaction fees, etc. shall be solely borne by You. IMPORTANT: You must
            inform Your bank/ financial payment partner that “Sender pays all fees" to
            ensure that the full invoice amount is received by Qure.
          </li>
          <li>
            Any costs, fees, expenses or disbursements incurred by the Qure in recovering
            any monies payable by the Customer to Qure, including dishonoured cheques,
            failed wire transfers, debt collection agency fees, legal costs and interest
            thereon shall be paid by the Customer on a full indemnity basis.
          </li>
          <li>
            You shall submit a payment advice detailing the invoice(s) against which each
            payment is made along with the details of TDS, if any, simultaneously with the
            payment. Such payment advice along with a soft copy of the TDS certificate
            shall be submitted to email id&nbsp;
            <a href="mailto:finance@qure.ai">finance@qure.ai</a>&nbsp;. The format of
            payment advice is as below:
          </li>
        </ul>
      </div>
      <div>
        <div className="table-auto md:hidden">
          <div className="p-4">
            <div className="border border-gray-700">
              <div className="px-3 py-3">
                <div className="text-sm">InvoiceDate</div>
              </div>
              <div className="px-3 py-3">
                <div className="text-sm">Invoice No.</div>
              </div>
              <div className="px-3 py-3">
                <div className="text-sm">Gross Amount</div>
              </div>
              <div className="px-3 py-3">
                <div className="text-sm">TDS</div>
              </div>
              <div className="px-3 py-3">
                <div className="text-sm">Net Amount</div>
              </div>
              <div className="px-3 py-3">
                <div className="text-sm">Payment Date</div>
              </div>
              <div className="px-3 py-3">
                <div className="text-sm">UTR No. / NEFT No. / Bank Instrument No.</div>
              </div>
            </div>
          </div>
        </div>
        <table className="hidden table-auto md:block">
          <tbody className="p-4">
            <tr className="border border-gray-700">
              <td className="border border-gray-700 px-3 py-3">
                <div className="text-sm">InvoiceDate</div>
              </td>
              <td className="border border-gray-700 px-3 py-3">
                <div className="text-sm">Invoice No.</div>
              </td>
              <td className="border border-gray-700 px-3 py-3">
                <div className="text-sm">Gross Amount</div>
              </td>
              <td className="border border-gray-700 px-3 py-3">
                <div className="text-sm">TDS</div>
              </td>
              <td className="border border-gray-700 px-3 py-3">
                <div className="text-sm">Net Amount</div>
              </td>
              <td className="border border-gray-700 px-3 py-3">
                <div className="text-sm">Payment Date</div>
              </td>
              <td className="border border-gray-700 px-3 py-3">
                <div className="text-sm">UTR No. / NEFT No. / Bank Instrument No.</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>PERSONAL DATA PROTECTION</li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            We shall not accept any protected health information or Personal Data as
            defined under the applicable laws, except as set out under these Universal
            Terms.All Data shall be de-identified by You before being provided to Us or
            uploaded on Our Services. No Personal Data will be disclosed by You to Us.
            Nevertheless, it is agreed that in the event that We come into contact with
            any Personal Data, We shall not use such information for any purpose or
            disclose it to any third parties, except as required by applicable law.You,
            including Your authorized personnel shall view and Process the Data only on a
            need-to-know basis and only to the extent necessary to perform Your
            obligations under the Universal Terms or as expressly instructed by Qure in
            writing. You agree to not disclose Data to third parties without having first
            received express written approval from Qure.The&nbsp;
            <a
              rel="noreferrer"
              href="https://qure.ai/legal/#legal-disclaimer/:~:text=Data%20Processing%20Agreement%C2%A0,-(v1.0.0%20dated%3A%2031.05.2022"
              target="_blank"
            >
              Data Processing Agreement
            </a>
            &nbsp;(“DPA“), forms part of and is subject to these Universal Terms. You
            acknowledge and confirm Your acceptance to the terms and conditions as set
            forth in the DPA and agree to abide by the Customer (as defined in DPA)
            obligations under the DPA.
          </li>
          <li>
            We shall not accept any protected health information or Personal Data as
            defined under the applicable laws, except as set out under these Universal
            Terms.All Data shall be de-identified by You before being provided to Us or
            uploaded on Our Services. No Personal Data will be disclosed by You to Us.
            Nevertheless, it is agreed that in the event that We come into contact with
            any Personal Data, We shall not use such information for any purpose or
            disclose it to any third parties, except as required by applicable law.You,
            including Your authorized personnel shall view and Process the Data only on a
            need-to-know basis and only to the extent necessary to perform Your
            obligations under the Universal Terms or as expressly instructed by Qure in
            writing. You agree to not disclose Data to third parties without having first
            received express written approval from Qure.The&nbsp;
            <a
              rel="noreferrer"
              href="https://qure.ai/legal/#legal-disclaimer/:~:text=Data%20Processing%20Agreement%C2%A0,-(v1.0.0%20dated%3A%2031.05.2022"
              target="_blank"
            >
              Data Processing Agreement
            </a>
            &nbsp;(“DPA“), forms part of and is subject to these Universal Terms. You
            acknowledge and confirm Your acceptance to the terms and conditions as set
            forth in the DPA and agree to abide by the Customer (as defined in DPA)
            obligations under the DPA.
          </li>
          <li>
            We shall not accept any protected health information or Personal Data as
            defined under the applicable laws, except as set out under these Universal
            Terms.
          </li>
          <li>
            All Data shall be de-identified by You before being provided to Us or uploaded
            on Our Services. No Personal Data will be disclosed by You to Us.
            Nevertheless, it is agreed that in the event that We come into contact with
            any Personal Data, We shall not use such information for any purpose or
            disclose it to any third parties, except as required by applicable law.
          </li>
          <li>
            You, including Your authorized personnel shall view and Process the Data only
            on a need-to-know basis and only to the extent necessary to perform Your
            obligations under the Universal Terms or as expressly instructed by Qure in
            writing. You agree to not disclose Data to third parties without having first
            received express written approval from Qure.
          </li>
          <li>
            The&nbsp;
            <a
              rel="noreferrer"
              href="https://qure.ai/legal/#legal-disclaimer/:~:text=Data%20Processing%20Agreement%C2%A0,-(v1.0.0%20dated%3A%2031.05.2022"
              target="_blank"
            >
              Data Processing Agreement
            </a>
            &nbsp;(“DPA“), forms part of and is subject to these Universal Terms. You
            acknowledge and confirm Your acceptance to the terms and conditions as set
            forth in the DPA and agree to abide by the Customer (as defined in DPA)
            obligations under the DPA.
          </li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>CONFIDENTIALITY</li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            You shall at all times, from the date of accepting these Universal Terms
            maintain the secrecy of and shall keep confidential, any and all information
            and documents which You may come to know of / acquire in connection with use
            of Services (collectively “Confidential Information“) and shall not use or
            disclose such information except for discharge of Your respective obligations
            any agreement with Qure or if required by law.Confidential Information shall
            include all information and materials relating to or arising from use of
            Services in any form whatsoever, and information which is by its nature
            confidential or which the discloser advises the recipient is
            confidential.  Confidential Information shall not include information which is
            presently in the public domain or subsequently enters the public domain
            without any lapse on Your part.You shall not disclose any confidential
            information to any third party except that the disclosure is permitted to Your
            counsel and advisers and government officials to the extent necessary for the
            purpose of performing the transactions contemplated with Qure under any
            agreement. Such disclosure shall require prior written approval of Qure. You
            shall return information that has been obtained from Qure including (if any)
            copies that have been made either in paper or in softcopyYou shall keep in
            Your possession and treat Confidential Information as confidential regardless
            of when it is disclosed.You acknowledge that any breach of Confidential
            Information will cost irreparable injury to Qure, which cannot be compensated
            by monetary damages and as such Qure shall be entitled to seek injunctive
            relief against You for any threatened or actual breach of confidentiality.You
            shall return and/or destroy all Confidential Information received (including
            any copies or reproductions thereof) in Your possession or control file as
            soon as You permanently stop using Services but not later than seven (7) days
            from date of last such use of Services and shall cease to use any such
            Confidential Information. Proof in writing of such return, destruction and
            cessation shall be provided by You.You shall immediately inform Qure in
            writing in case of any unauthorized use or disclosure of Confidential
            Information to any third party.You shall cooperate with Qure in every
            reasonable way to help Qure regain possession of such Confidential Information
            and prevent its further unauthorized use.
          </li>
          <li>
            You shall at all times, from the date of accepting these Universal Terms
            maintain the secrecy of and shall keep confidential, any and all information
            and documents which You may come to know of / acquire in connection with use
            of Services (collectively “Confidential Information“) and shall not use or
            disclose such information except for discharge of Your respective obligations
            any agreement with Qure or if required by law.Confidential Information shall
            include all information and materials relating to or arising from use of
            Services in any form whatsoever, and information which is by its nature
            confidential or which the discloser advises the recipient is
            confidential.  Confidential Information shall not include information which is
            presently in the public domain or subsequently enters the public domain
            without any lapse on Your part.You shall not disclose any confidential
            information to any third party except that the disclosure is permitted to Your
            counsel and advisers and government officials to the extent necessary for the
            purpose of performing the transactions contemplated with Qure under any
            agreement. Such disclosure shall require prior written approval of Qure. You
            shall return information that has been obtained from Qure including (if any)
            copies that have been made either in paper or in softcopyYou shall keep in
            Your possession and treat Confidential Information as confidential regardless
            of when it is disclosed.You acknowledge that any breach of Confidential
            Information will cost irreparable injury to Qure, which cannot be compensated
            by monetary damages and as such Qure shall be entitled to seek injunctive
            relief against You for any threatened or actual breach of confidentiality.You
            shall return and/or destroy all Confidential Information received (including
            any copies or reproductions thereof) in Your possession or control file as
            soon as You permanently stop using Services but not later than seven (7) days
            from date of last such use of Services and shall cease to use any such
            Confidential Information. Proof in writing of such return, destruction and
            cessation shall be provided by You.You shall immediately inform Qure in
            writing in case of any unauthorized use or disclosure of Confidential
            Information to any third party.You shall cooperate with Qure in every
            reasonable way to help Qure regain possession of such Confidential Information
            and prevent its further unauthorized use.
          </li>
          <li>
            You shall at all times, from the date of accepting these Universal Terms
            maintain the secrecy of and shall keep confidential, any and all information
            and documents which You may come to know of / acquire in connection with use
            of Services (collectively “Confidential Information“) and shall not use or
            disclose such information except for discharge of Your respective obligations
            any agreement with Qure or if required by law.
          </li>
          <li>
            Confidential Information shall include all information and materials relating
            to or arising from use of Services in any form whatsoever, and information
            which is by its nature confidential or which the discloser advises the
            recipient is confidential.  Confidential Information shall not include
            information which is presently in the public domain or subsequently enters the
            public domain without any lapse on Your part.
          </li>
          <li>
            You shall not disclose any confidential information to any third party except
            that the disclosure is permitted to Your counsel and advisers and government
            officials to the extent necessary for the purpose of performing the
            transactions contemplated with Qure under any agreement. Such disclosure shall
            require prior written approval of Qure. You shall return information that has
            been obtained from Qure including (if any) copies that have been made either
            in paper or in softcopy
          </li>
          <li>
            You shall keep in Your possession and treat Confidential Information as
            confidential regardless of when it is disclosed.
          </li>
          <li>
            You acknowledge that any breach of Confidential Information will cost
            irreparable injury to Qure, which cannot be compensated by monetary damages
            and as such Qure shall be entitled to seek injunctive relief against You for
            any threatened or actual breach of confidentiality.
          </li>
          <li>
            You shall return and/or destroy all Confidential Information received
            (including any copies or reproductions thereof) in Your possession or control
            file as soon as You permanently stop using Services but not later than seven
            (7) days from date of last such use of Services and shall cease to use any
            such Confidential Information. Proof in writing of such return, destruction
            and cessation shall be provided by You.
          </li>
          <li>
            You shall immediately inform Qure in writing in case of any unauthorized use
            or disclosure of Confidential Information to any third party.You shall
            cooperate with Qure in every reasonable way to help Qure regain possession of
            such Confidential Information and prevent its further unauthorized use.
          </li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>INTELLECTUAL PROPERTY&nbsp;</li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            Under an agreement in writing with You, Qure may grant You certain rights/
            license to use Qure’s products, software, or Devices solely for a purpose
            mentioned in the agreement therein. You shall not directly or indirectly
            transfer, assign, sub-license to any third party or in any manner permit
            Qure’s products, software, or Devices to be used outside the designated
            territory, beyond the designated use and beyond designated Users as mentioned
            in the agreement. Notwithstanding anything contained herein, You or Your
            representatives shall not, directly or indirectly, reverse engineer or aid or
            assist in the reverse engineering of all or any part of Qure’s products,
            software or Devices. Reverse engineering includes, without limitation,
            decompiling, disassembly, sniffing, peeling semiconductor components, or
            otherwise deriving source code.You hereby acknowledge and confirm that all
            intellectual property rights relating to the trademarks, service-marks,
            copyrights (including in Services), patent, trade-names including Our
            corporate name or any part thereof, are owned by, licensed to, possessed by or
            belong to Qure and nothing contained in herein shall be deemed to authorize
            You to use or give any rights with respect to Qure’s Intellectual Property.
          </li>
          <li>
            Under an agreement in writing with You, Qure may grant You certain rights/
            license to use Qure’s products, software, or Devices solely for a purpose
            mentioned in the agreement therein. You shall not directly or indirectly
            transfer, assign, sub-license to any third party or in any manner permit
            Qure’s products, software, or Devices to be used outside the designated
            territory, beyond the designated use and beyond designated Users as mentioned
            in the agreement. Notwithstanding anything contained herein, You or Your
            representatives shall not, directly or indirectly, reverse engineer or aid or
            assist in the reverse engineering of all or any part of Qure’s products,
            software or Devices. Reverse engineering includes, without limitation,
            decompiling, disassembly, sniffing, peeling semiconductor components, or
            otherwise deriving source code.You hereby acknowledge and confirm that all
            intellectual property rights relating to the trademarks, service-marks,
            copyrights (including in Services), patent, trade-names including Our
            corporate name or any part thereof, are owned by, licensed to, possessed by or
            belong to Qure and nothing contained in herein shall be deemed to authorize
            You to use or give any rights with respect to Qure’s Intellectual Property.
          </li>
          <li>
            Under an agreement in writing with You, Qure may grant You certain rights/
            license to use Qure’s products, software, or Devices solely for a purpose
            mentioned in the agreement therein. You shall not directly or indirectly
            transfer, assign, sub-license to any third party or in any manner permit
            Qure’s products, software, or Devices to be used outside the designated
            territory, beyond the designated use and beyond designated Users as mentioned
            in the agreement. Notwithstanding anything contained herein, You or Your
            representatives shall not, directly or indirectly, reverse engineer or aid or
            assist in the reverse engineering of all or any part of Qure’s products,
            software or Devices. Reverse engineering includes, without limitation,
            decompiling, disassembly, sniffing, peeling semiconductor components, or
            otherwise deriving source code.
          </li>
          <li>
            You hereby acknowledge and confirm that all intellectual property rights
            relating to the trademarks, service-marks, copyrights (including in Services),
            patent, trade-names including Our corporate name or any part thereof, are
            owned by, licensed to, possessed by or belong to Qure and nothing contained in
            herein shall be deemed to authorize You to use or give any rights with respect
            to Qure’s Intellectual Property.
          </li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>INDEMNIFICATION</li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            You&nbsp; hereby agree to indemnify, defend and hold harmless Us, Our
            employees, members, directors, managers and officers from and against any
            loss, liability, damage, penalty or expense including attorneys’ fees and
            costs of defense which We may suffer or incur as a result of (i) any gross
            negligence or willful misconduct or fraud by You, Your employees or agents;
            (ii) breach of the representation, warranty and undertakings made and agreed
            by You under these Universal Terms or under any agreement with Qure and
            policies or documents they incorporates by reference, or Your violation of any
            law, rules or regulation; (iii) breach of confidentiality (iv) by the use of
            the Data in the Services.In no event shall Qure have any liability to You or
            any Users for any damages whatsoever, including direct, indirect, special,
            incidental, punitive, exemplary or consequential damages, or damages based on
            lost profits, however caused and, whether in contract, tort or under any other
            theory of liability, regardless of whether such damages were foreseeable or
            whether You were advised of the possibility of such damages.The Services may
            include programs or code that are licensed under an Open-Source Software
            (“OSS“) license model. OSS programs and code are subject to the terms,
            conditions, and obligations of the applicable OSS license, and are
            specifically excluded from all warranty and support obligations described
            elsewhere in these Universal Terms.The Services may contain independent
            third-party products (software or hardware) which are not manufactured or
            developed by Qure and rely upon such third-party products (software or
            hardware) to perform certain functionality. Qure make no warranties either
            expressed or implied as to the accuracy of any such third-party products
            (software or hardware). Third party technology that may be appropriate or
            necessary for use with some software or hardware may be specified in the
            relevant documentations. The subscriber’s right to use such third-party
            technology is governed by the terms of the third-party technology license
            agreement specified by Us and not by these Universal Terms.The Qure App may
            contain (or You may be sent through the Site) links to other websites or
            content belonging to or originating from third parties or links to websites
            and features in banners or other advertising. Such external links are not
            investigated, monitored, or checked for accuracy, adequacy, validity,
            reliability, availability or completeness by us. We do not warrant, endorse,
            guarantee, or assume responsibility for the accuracy or reliability of any
            information offered by third party website/app linked through the Qure App. We
            will not be a party to or in any way responsible for monitoring any
            transactions between You and third-party providers of products or services.
          </li>
          <li>
            You&nbsp; hereby agree to indemnify, defend and hold harmless Us, Our
            employees, members, directors, managers and officers from and against any
            loss, liability, damage, penalty or expense including attorneys’ fees and
            costs of defense which We may suffer or incur as a result of (i) any gross
            negligence or willful misconduct or fraud by You, Your employees or agents;
            (ii) breach of the representation, warranty and undertakings made and agreed
            by You under these Universal Terms or under any agreement with Qure and
            policies or documents they incorporates by reference, or Your violation of any
            law, rules or regulation; (iii) breach of confidentiality (iv) by the use of
            the Data in the Services.In no event shall Qure have any liability to You or
            any Users for any damages whatsoever, including direct, indirect, special,
            incidental, punitive, exemplary or consequential damages, or damages based on
            lost profits, however caused and, whether in contract, tort or under any other
            theory of liability, regardless of whether such damages were foreseeable or
            whether You were advised of the possibility of such damages.The Services may
            include programs or code that are licensed under an Open-Source Software
            (“OSS“) license model. OSS programs and code are subject to the terms,
            conditions, and obligations of the applicable OSS license, and are
            specifically excluded from all warranty and support obligations described
            elsewhere in these Universal Terms.The Services may contain independent
            third-party products (software or hardware) which are not manufactured or
            developed by Qure and rely upon such third-party products (software or
            hardware) to perform certain functionality. Qure make no warranties either
            expressed or implied as to the accuracy of any such third-party products
            (software or hardware). Third party technology that may be appropriate or
            necessary for use with some software or hardware may be specified in the
            relevant documentations. The subscriber’s right to use such third-party
            technology is governed by the terms of the third-party technology license
            agreement specified by Us and not by these Universal Terms.The Qure App may
            contain (or You may be sent through the Site) links to other websites or
            content belonging to or originating from third parties or links to websites
            and features in banners or other advertising. Such external links are not
            investigated, monitored, or checked for accuracy, adequacy, validity,
            reliability, availability or completeness by us. We do not warrant, endorse,
            guarantee, or assume responsibility for the accuracy or reliability of any
            information offered by third party website/app linked through the Qure App. We
            will not be a party to or in any way responsible for monitoring any
            transactions between You and third-party providers of products or services.
          </li>
          <li>
            You&nbsp; hereby agree to indemnify, defend and hold harmless Us, Our
            employees, members, directors, managers and officers from and against any
            loss, liability, damage, penalty or expense including attorneys’ fees and
            costs of defense which We may suffer or incur as a result of (i) any gross
            negligence or willful misconduct or fraud by You, Your employees or agents;
            (ii) breach of the representation, warranty and undertakings made and agreed
            by You under these Universal Terms or under any agreement with Qure and
            policies or documents they incorporates by reference, or Your violation of any
            law, rules or regulation; (iii) breach of confidentiality (iv) by the use of
            the Data in the Services.
          </li>
          <li>
            In no event shall Qure have any liability to You or any Users for any damages
            whatsoever, including direct, indirect, special, incidental, punitive,
            exemplary or consequential damages, or damages based on lost profits, however
            caused and, whether in contract, tort or under any other theory of liability,
            regardless of whether such damages were foreseeable or whether You were
            advised of the possibility of such damages.
          </li>
          <li>
            The Services may include programs or code that are licensed under an
            Open-Source Software (“OSS“) license model. OSS programs and code are subject
            to the terms, conditions, and obligations of the applicable OSS license, and
            are specifically excluded from all warranty and support obligations described
            elsewhere in these Universal Terms.
          </li>
          <li>
            The Services may contain independent third-party products (software or
            hardware) which are not manufactured or developed by Qure and rely upon such
            third-party products (software or hardware) to perform certain functionality.
            Qure make no warranties either expressed or implied as to the accuracy of any
            such third-party products (software or hardware). Third party technology that
            may be appropriate or necessary for use with some software or hardware may be
            specified in the relevant documentations. The subscriber’s right to use such
            third-party technology is governed by the terms of the third-party technology
            license agreement specified by Us and not by these Universal Terms.
          </li>
          <li>
            The Qure App may contain (or You may be sent through the Site) links to other
            websites or content belonging to or originating from third parties or links to
            websites and features in banners or other advertising. Such external links are
            not investigated, monitored, or checked for accuracy, adequacy, validity,
            reliability, availability or completeness by us. We do not warrant, endorse,
            guarantee, or assume responsibility for the accuracy or reliability of any
            information offered by third party website/app linked through the Qure App. We
            will not be a party to or in any way responsible for monitoring any
            transactions between You and third-party providers of products or services.
          </li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>LIMITATION OF LIABILITY</li>
        </ul>
      </div>
      <div>
        <div>
          To the maximum extent permitted by applicable law, in no event shall Qure be
          liable to You for any special, incidental, punitive, indirect, or consequential
          damages whatsoever (including, but not limited to, damages for loss of profits
          or wrong medical image tag detection or missed image tag detection (both
          omission and commission) or confidential or other information, for business
          interruption, for personal injury,&nbsp; for loss of privacy, for failure to
          meet any duty including of reasonable care, for negligence, and for any other
          pecuniary or other loss whatsoever) arising out of or in any way related to the
          use of or inability to use the Services, the provision of or failure to provide
          support or other Services, information, software, and related content through
          the Services or otherwise arising out of the use of the Services including, but
          not limited to, any clinical diagnosis, misdiagnosis or consequences to patient
          well-being and software performance changes or failures to You that may result
          directly or indirectly from integrating with the Services
        </div>
      </div>
      <div>
        <div>
          None of the individual authors, contributors, developers of these Terms nor
          anyone else connected to Qure in take any responsibility for the results or
          consequences of any attempt to use or adopt any of the information presented by
          these Terms.
        </div>
      </div>
      <div>
        <div>12. WARRANTY</div>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            All information on the Services is provided in good faith, however /Without
            prejudice to the generality of the foregoing paragraph, Qure does not warrant
            that the medical information in these Universal Terms is complete, true,
            accurate, up-to-date, or non-misleading. Neither does Qure assumes legal
            liability or responsibility for the points mentioned above.Any misuse or abuse
            of the Qure’s Services, Website and mobile application is strictly
            prohibited.The Services and documentation are made available to You “as is”
            and without warranty of any kind. Qure specifically disclaims all warranties,
            express or implied, including without limitation, warranties of
            merchantability, fitness for a particular purpose and non-infringement. Qure
            does not warrant that Services, documentation, or any other information,
            materials and/or Data provided hereunder will meet Your requirements or is
            complete, accurate or error-free. You shall not make any representations or
            warranties on behalf of Qure. You are solely responsible for backing up any of
            Your Data.
          </li>
          <li>
            All information on the Services is provided in good faith, however /Without
            prejudice to the generality of the foregoing paragraph, Qure does not warrant
            that the medical information in these Universal Terms is complete, true,
            accurate, up-to-date, or non-misleading. Neither does Qure assumes legal
            liability or responsibility for the points mentioned above.Any misuse or abuse
            of the Qure’s Services, Website and mobile application is strictly
            prohibited.The Services and documentation are made available to You “as is”
            and without warranty of any kind. Qure specifically disclaims all warranties,
            express or implied, including without limitation, warranties of
            merchantability, fitness for a particular purpose and non-infringement. Qure
            does not warrant that Services, documentation, or any other information,
            materials and/or Data provided hereunder will meet Your requirements or is
            complete, accurate or error-free. You shall not make any representations or
            warranties on behalf of Qure. You are solely responsible for backing up any of
            Your Data.
          </li>
          <li>
            All information on the Services is provided in good faith, however /Without
            prejudice to the generality of the foregoing paragraph, Qure does not warrant
            that the medical information in these Universal Terms is complete, true,
            accurate, up-to-date, or non-misleading. Neither does Qure assumes legal
            liability or responsibility for the points mentioned above.
          </li>
          <li>
            Any misuse or abuse of the Qure’s Services, Website and mobile application is
            strictly prohibited.
          </li>
          <li>
            The Services and documentation are made available to You “as is” and without
            warranty of any kind. Qure specifically disclaims all warranties, express or
            implied, including without limitation, warranties of merchantability, fitness
            for a particular purpose and non-infringement. Qure does not warrant that
            Services, documentation, or any other information, materials and/or Data
            provided hereunder will meet Your requirements or is complete, accurate or
            error-free. You shall not make any representations or warranties on behalf of
            Qure. You are solely responsible for backing up any of Your Data.
          </li>
        </ul>
      </div>
      <div>
        <div>13. TESTIMONIAL DISCLAIMER</div>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>
            The Site may contain testimonials by Users of Our Services. These testimonials
            reflect the real-life experiences and opinions of such Users. However, the
            experiences are personal to those particular Users, and may not necessarily be
            representative of all Users of Our Services. We do not claim, and You should
            not assume, that all Users will have the same experiences. YOUR INDIVIDUAL
            RESULTS MAY VARY.The testimonials on the Site are submitted in various forms
            such as text, audio and/or video, and are reviewed by Us before being posted.
            They appear on the Site verbatim as given by the Users, except for the
            correction of grammar or typing errors. Some testimonials may have been
            shortened for the sake of brevity where the full testimonial contained
            extraneous information not relevant to the general public.The views and
            opinions contained in the testimonials belong solely to the individual User
            and do not reflect Our views and opinions. We are not affiliated with Users
            who provide testimonials, and Users are not paid or otherwise compensated for
            their testimonials
          </li>
          <li>
            The Site may contain testimonials by Users of Our Services. These testimonials
            reflect the real-life experiences and opinions of such Users. However, the
            experiences are personal to those particular Users, and may not necessarily be
            representative of all Users of Our Services. We do not claim, and You should
            not assume, that all Users will have the same experiences. YOUR INDIVIDUAL
            RESULTS MAY VARY.The testimonials on the Site are submitted in various forms
            such as text, audio and/or video, and are reviewed by Us before being posted.
            They appear on the Site verbatim as given by the Users, except for the
            correction of grammar or typing errors. Some testimonials may have been
            shortened for the sake of brevity where the full testimonial contained
            extraneous information not relevant to the general public.The views and
            opinions contained in the testimonials belong solely to the individual User
            and do not reflect Our views and opinions. We are not affiliated with Users
            who provide testimonials, and Users are not paid or otherwise compensated for
            their testimonials
          </li>
          <li>
            The Site may contain testimonials by Users of Our Services. These testimonials
            reflect the real-life experiences and opinions of such Users. However, the
            experiences are personal to those particular Users, and may not necessarily be
            representative of all Users of Our Services. We do not claim, and You should
            not assume, that all Users will have the same experiences. YOUR INDIVIDUAL
            RESULTS MAY VARY.
          </li>
          <li>
            The testimonials on the Site are submitted in various forms such as text,
            audio and/or video, and are reviewed by Us before being posted. They appear on
            the Site verbatim as given by the Users, except for the correction of grammar
            or typing errors. Some testimonials may have been shortened for the sake of
            brevity where the full testimonial contained extraneous information not
            relevant to the general public.
          </li>
          <li>
            The views and opinions contained in the testimonials belong solely to the
            individual User and do not reflect Our views and opinions. We are not
            affiliated with Users who provide testimonials, and Users are not paid or
            otherwise compensated for their testimonials
          </li>
        </ul>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>PRIVACY</li>
        </ul>
      </div>
      <div>
        <div>
          Any personal information provided to Qure will be dealt with in accordance with
          Qure’s&nbsp;<a href="https://qure.ai/privacy-policy/">privacy policy</a>. Any
          information provided may be accessed by any employee of Qure and its related
          companies in accordance with the requirement of Qure’s&nbsp;
          <a href="https://qure.ai/privacy-policy/">privacy policy</a>.
        </div>
      </div>
      <div>
        <ul className="!list-disc space-y-3">
          <li>MISCELLANEOUS</li>
        </ul>
      </div>
      <div>
        <div>
          Assignment: Any rights or obligations hereunder may be assigned by Qure without
          Your prior written consent. However, You shall not assign any rights or
          obligations hereunder without the prior written consent of Qure. These Terms
          bind, and inure to the benefit of, the Parties and their respective successors
          and permitted assigns.
        </div>
      </div>
      <div>
        <div>
          Entire Agreement: The Terms together constitute the entire agreement and
          supersede any and all prior agreements between You and Qure with regard to the
          subject matter hereof. The Terms shall prevail over the terms or conditions in
          any purchase order or other order documentation You or any entity that You
          represent provides (all such terms or conditions being null and void), unless
          otherwise agreed and accepted in writing by Qure.
        </div>
      </div>
      <div>
        <div>
          Amendment: We may amend these Universal Terms from time to time, in which case
          the new Universal Terms will supersede prior versions. We will notify You of any
          material revisions not less than ten (10) days prior to the effective date of
          any amendments to these Universal Terms and Your continued use of the Services
          following the effective date of any such amendment may be relied upon by Us as
          Your acceptance of any such amendment. You can review the most current version
          of the Universal Terms at any time by visiting this page.
        </div>
      </div>
      <div>
        <div>
          Severability; No Waiver: If any provision in these Universal Terms is held by a
          court of competent jurisdiction to be unenforceable, such provision shall be
          modified by the court and interpreted so as to best accomplish the original
          provision to the fullest extent permitted by applicable law, and the remaining
          provisions of these Universal Terms shall remain in effect. Qure’s non-exercise
          of any right under any provision of these Universal Terms does not constitute a
          waiver of that right or provision of these Universal Terms.
        </div>
      </div>
      <div>
        <div>
          Relationship of the Parties: The Parties are independent contractors. These
          Universal Terms do not create a partnership, franchise, joint venture, agency,
          fiduciary or employment relationship among the Parties.
        </div>
      </div>
      <div>
        <div>
          Survival: All clauses which, by their nature are intended to survive, including
          without limitation clauses&nbsp;1 (Definitions), 3 (Your / Customer’s
          Representations And Warranties), 7(Personal Data Protection), 8
          (Confidentiality), 9 (Intellectual Property), 10 (Indemnification), 11
          (Limitation Of Liability), 12 (Warranty)&nbsp;15 (Miscellaneous),&nbsp;shall
          survive any termination of Qure’s agreement with respect to use of the Services
          by You. Termination shall not limit either Party’s liability for obligations
          accrued as of or prior to such termination or for any breach of the Terms.
        </div>
      </div>
      <div>
        <div>
          Notices and Consent to Electronic Communications: All notices to be provided by
          Qure to You under these Terms may be delivered in writing (i) by nationally
          recognized overnight delivery service (“Courier”) or to the contact mailing
          address provided by You on subscribing to the Services; or (ii) electronic mail
          to the e-mail address provided by You. Qure’s address for a notice to Qure in
          writing by Courier is&nbsp;7th Floor, Oberoi Commerz-II, International, Business
          Park, Oberoi Garden City, Off Western, Express Highway, Goregaon East, Mumbai,
          Maharashtra, 400063, India&nbsp;with a CC to&nbsp;
          <a href="mailto:partner@qure.ai">partner@qure.ai</a>&nbsp;for electronic mail.
          All notices shall be deemed to have been given immediately upon delivery by
          electronic mail, or if otherwise delivered upon receipt of mail or Courier as
          permitted above.
        </div>
      </div>
      <div>
        <div>
          Publicity Rights: You hereby grant Qure the right to identify Yourself as Qure’s
          Customer on Qure’s websites and/or marketing collateral and to include Your use
          of the Services in case studies, research. You shall not use the trademark,
          trade name or the Qure logo or any other mark or logo of Qure, except with the
          prior written consent and as per the directions of Qure.
        </div>
      </div>
      <div>
        <div>
          Change in Law:&nbsp;Qure shall not be liable for any increase in costs or
          reduction in net after Tax return or other financial burden, loss, liability or
          damage on You arising as a result of Change in Law. You acknowledge and agree
          that it shall not be entitled to any compensation from Qure in the event of any
          Change in Law or the operation or enforcement of current applicable laws.
          “Change in Law” for the purposes of this clause means the enactment, adoption,
          promulgation, modification or repeal (including any change in interpretation or
          application by the relevant authorities), of any applicable law.
        </div>
      </div>
      <div>
        <div>
          Governing Law &amp; Jurisdiction:&nbsp;These Universal Terms and all rights,
          duties and obligations arising hereunder shall be governed by and in accordance
          with the laws of India; notwithstanding any conflicts of laws principles.
          Subject to Dispute Resolution clause below, Parties submit to the exclusive
          jurisdiction of the courts at Mumbai. The Parties waive any objections to such
          jurisdiction, including venue and inconvenient forum.
        </div>
      </div>
      <div>
        <div>
          Dispute Resolution:&nbsp;Any dispute arising under, relating to or in connection
          with these Universal Terms, or the breach hereof, including any question
          regarding its existence, validity or termination, shall be resolved by mediation
          first, failing which they shall be referred to and finally resolved by
          arbitration in accordance with the arbitration rules of the Mumbai Centre for
          International Arbitration (“MCIA&nbsp;Rules”), which rules are deemed to be
          incorporated by reference in this clause. The award rendered by the arbitrator
          shall be final and binding on the Parties. The arbitration shall be conducted by
          a sole arbitrator, who will be appointed by MCIA in accordance with MCIA Rules.
          The seat and the venue of the arbitration shall be Mumbai. The language to be
          used in the arbitral proceedings shall be English.
        </div>
      </div>
      <div>
        <div>
          Class Action Waiver:&nbsp;Any Claim brought by You or Your Users against Qure
          shall be under individual capacity, and not as a plaintiff or class member in
          any purported class, collective, representative, multiple plaintiff, or similar
          proceeding (“Class Action”). You expressly waive any ability to maintain any
          Class Action in any forum. If the Claim is subject to arbitration, the
          arbitrator will not have authority to combine or aggregate similar claims or
          conduct any Class Action nor make an award to any person or entity not a party
          to the arbitration. Any claim that all or part of this Class Action Waiver is
          unenforceable, unconscionable, void, or voidable may be determined only by a
          court of competent jurisdiction and not by an arbitrator. You understand that
          any right to litigate in court, to have a judge or jury decide their case, or to
          be a party to a class or representative action, is waived, and that any claims
          must be decided individually.
        </div>
      </div>
      <div>
        <div>
          Injunctive Relief.&nbsp;You agree that a breach of Terms will cause irreparable
          injury to Qure for which monetary damages would not be an adequate remedy and
          Qure shall be entitled to equitable relief in addition to any remedies it may
          have hereunder or at law or equity without any proof of damages.
        </div>
      </div>
      <div>
        <div>
          Disclosure:&nbsp;We reserve the right to access, read, preserve, and disclose
          any information that We obtain in connection with the Site, and Your use
          thereof, as We reasonably believe is necessary to (i) satisfy any applicable
          law, regulation, legal process, subpoena or governmental request, (ii) enforce
          the Terms, including to investigate potential violations of them, (iii) detect,
          prevent, or otherwise address fraud, security or technical issues, (iv) respond
          to User support requests, or (v) protect the rights, property or safety of Qure,
          its Users or the public.
        </div>
      </div>
      <div>
        <div>
          Consent to Electronic Communications and Solicitation: By downloading the Qure
          App, and/or opting-in through notification settings, You authorize Qure to send
          You (including via email and push notifications) information regarding the
          Services, such as: (a) notices about Your use of the Services, including notices
          of violations of use; (b) Updates to the Service and App and new features or
          products; and (c) promotional information and materials regarding Qure’s
          Services. You can review and/or unsubscribe to such notifications by following
          instructions as provided by Qure in the Services.
        </div>
      </div>
      <div>
        <table className="table-auto hidden md:block text-sm text-center">
          <thead>
            <tr className="border border-gray-700">
              <th className="border-r border-gray-700 px-4">Product Name</th>
              <th className="border-r border-gray-700 px-4">EU Legislation</th>
              <th className="border-r border-gray-700 px-4">Classification</th>
              <th className="border-r border-gray-700 px-4">
                MDD Classification Rule basis of the product claim
              </th>
              <th className="px-4">Indications for Use</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">
                qXR - Chest X-Ray Interpretation software v3.1
              </td>
              <td className="border-r border-gray-700 px-4">MDD</td>
              <td className="border-r border-gray-700 px-4">Class IIa</td>
              <td className="border-r border-gray-700 px-4">Indent 3 of Rule 10</td>
              <td className="px-4 text-left">
                Normal, Blunted Costophrenic Angle, Cardiomegaly, Cavity, Fibrosis,
                Consolidation, Hilar Enlargement, Nodule, Opacity, Pleural Effusion,
                Pneumothorax and Radiological signs of Tuberculosis
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qXR v3.2</td>
              <td className="border-r border-gray-700 px-4">MDD</td>
              <td className="border-r border-gray-700 px-4">Class I</td>
              <td className="border-r border-gray-700 px-4">Rule 12</td>
              <td className="px-4 text-left">
                Abnormal, Cardiomegaly, Hyperinflation/ Emphysema, Degenerative spine
                conditions, Pleural effusion, Prominence in the Hilar region, Opacity,
                Blunted Costophrenic Angle, Scoliosis, Consolidation, Tracheal shift,
                Fibrosis, Tuberculosis, Atelectasis, Reticulonodular pattern, Nodules,
                Cavity, Pneumothorax, Calcification, Covid-19 risk, Elevated
                Hemidiaphragm, Pneumoperitoneum, Rib fractures, Mediastinal Widening,
                Linear Opacities, Presence of tracheal tube, Presence of gastric tube,
                Placement of tracheal tube, Placement of gastric tube , Lung nodule
                malignancy
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qXR - CC v1.0</td>
              <td className="border-r border-gray-700 px-4">MDD</td>
              <td className="border-r border-gray-700 px-4">Class I</td>
              <td className="border-r border-gray-700 px-4">Rule 12</td>
              <td className="px-4 text-left">
                Rib fractures, Mediastinal Widening, Pneumoperitoneum, Presence of
                tracheal tube, Presence of gastric tube, Placement of tracheal tube,
                Placement of gastric tube, Pneumothorax, SARS-CoV-2 (Covid-19) risk
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">
                qER - Head CT scan Interpretation software v2.0 EU
              </td>
              <td className="border-r border-gray-700 px-4">MDD</td>
              <td className="border-r border-gray-700 px-4">Class IIa</td>
              <td className="border-r border-gray-700 px-4">Indent 3 of Rule 10</td>
              <td className="px-4 text-left">
                Intracranial hemorrhage and its subtypes, mass effect, midline shift,
                cranial fracture, hypodensities suggesting an Infarct and cerebral
                atrophy. qERv2.0 EU’s intended use includes localization, so overlays are
                claimed. + qQuant (ICH and subtypes, Lateral ventricles, and midline
                shift)
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qER v2.1</td>
              <td className="border-r border-gray-700 px-4">MDD</td>
              <td className="border-r border-gray-700 px-4">Class I</td>
              <td className="border-r border-gray-700 px-4">Rule 12</td>
              <td className="px-4 text-left">
                Intracranial hemorrhage and its subtypes, mass effect, midline shift,
                cranial fracture, hypodensities suggesting an Infarct and cerebral
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qCT-Lung v1.0</td>
              <td className="border-r border-gray-700 px-4">MDD</td>
              <td className="border-r border-gray-700 px-4">Class I</td>
              <td className="border-r border-gray-700 px-4">Rule 12</td>
              <td className="px-4 text-left">Nodule and Emphysema</td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qER- NCCT v1.0</td>
              <td className="border-r border-gray-700 px-4">MDR</td>
              <td className="border-r border-gray-700 px-4">Class IIb</td>
              <td className="border-r border-gray-700 px-4">Rule 11</td>
              <td className="px-4 text-left">
                <strong>qERv2.0</strong> (ICH and subtypes, Midline Shift, Mass effect,
                Cranial Fractures) + <strong>qQuant</strong> (ICH, Lateral ventricles, and
                midline shift)
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qCTv1.0</td>
              <td className="border-r border-gray-700 px-4">MDR</td>
              <td className="border-r border-gray-700 px-4">Class IIb</td>
              <td className="border-r border-gray-700 px-4">Rule 11</td>
              <td className="px-4 text-left">
                Nodule detected based on size, type, count, location, and presence of
                spiculation (type of texture) and calcification. Measurement of long axis,
                short axis diameter and volume of nodule.
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qXRv4.0</td>
              <td className="border-r border-gray-700 px-4">MDR</td>
              <td className="border-r border-gray-700 px-4">Class IIb</td>
              <td className="border-r border-gray-700 px-4">Rule 11</td>
              <td className="px-4 text-left">
                Normal, Atelectasis, Blunted Costophrenic Angle, Non-Aortic Calcification,
                Degenerative Spine Conditions, Hyperinflation/ Emphysema, Reticulonodular
                Pattern, Scoliosis, Tracheal shift, Elevated Hemidiaphragm, Cardiomegaly,
                Cavity, Consolidation, Fibrosis, Hilar Enlargement, Nodule, Opacity,
                Pleural Effusion, Pneumothorax, Rib Fractures, Lung Nodule Malignancy
                Score, Radiological signs of Tuberculosis & Mass, and measure the distance
                between the tip of the breathing tube (endotracheal or tracheostomy tube)
                and carina (Indications for use 24-25).
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qMSKv1.0</td>
              <td className="border-r border-gray-700 px-4">MDR</td>
              <td className="border-r border-gray-700 px-4">Class IIb</td>
              <td className="border-r border-gray-700 px-4">Rule 11</td>
              <td className="px-4 text-left">
                Ankle, Clavicle, Elbow, Femur, Forearm, Hip, Humerus, Knee, Pelvis, Rib,
                Shoulder, Tibia / Fibula, Wrist, Toe, Foot, Finger and Hand
              </td>
            </tr>
          </tbody>
        </table>
        <div className="border border-gray-700 md:hidden text-sm table-auto">
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qXR - Chest X-Ray Interpretation software
              v3.1
            </div>
            <div>
              <strong>EU Legislation:</strong> MDD
            </div>
            <div>
              <strong>Classification:</strong> Class IIa
            </div>
            <div>
              <strong>MDD Classification Rule basis of the product claim:</strong> Indent
              3 of Rule 10
            </div>
            <div>
              <strong>Indications for Use:</strong> Normal, Blunted Costophrenic Angle,
              Cardiomegaly, Cavity, Fibrosis, Consolidation, Hilar Enlargement, Nodule,
              Opacity, Pleural Effusion, Pneumothorax and Radiological signs of
              Tuberculosis
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qXR v3.2
            </div>
            <div>
              <strong>EU Legislation:</strong> MDD
            </div>
            <div>
              <strong>Classification:</strong> Class I
            </div>
            <div>
              <strong>MDD Classification Rule basis of the product claim:</strong> Rule 12
            </div>
            <div>
              <strong>Indications for Use:</strong> Abnormal, Cardiomegaly,
              Hyperinflation/ Emphysema, Degenerative spine conditions, Pleural effusion,
              Prominence in the Hilar region, Opacity, Blunted Costophrenic Angle,
              Scoliosis, Consolidation, Tracheal shift, Fibrosis, Tuberculosis,
              Atelectasis, Reticulonodular pattern, Nodules, Cavity, Pneumothorax,
              Calcification, Covid-19 risk, Elevated Hemidiaphragm, Pneumoperitoneum, Rib
              fractures, Mediastinal Widening, Linear Opacities, Presence of tracheal
              tube, Presence of gastric tube, Placement of tracheal tube, Placement of
              gastric tube , Lung nodule malignancy
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qXR - CC v1.0
            </div>
            <div>
              <strong>EU Legislation:</strong> MDD
            </div>
            <div>
              <strong>Classification:</strong> Class I
            </div>
            <div>
              <strong>MDD Classification Rule basis of the product claim:</strong> Rule 12
            </div>
            <div>
              <strong>Indications for Use:</strong> Rib fractures, Mediastinal Widening,
              Pneumoperitoneum, Presence of tracheal tube, Presence of gastric tube,
              Placement of tracheal tube, Placement of gastric tube, Pneumothorax,
              SARS-CoV-2 (Covid-19) risk
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qER - Head CT scan Interpretation software
              v2.0 EU
            </div>
            <div>
              <strong>EU Legislation:</strong> MDD
            </div>
            <div>
              <strong>Classification:</strong> Class IIb
            </div>
            <div>
              <strong>MDD Classification Rule basis of the product claim:</strong> Indent
              3 of Rule 10
            </div>
            <div>
              <strong>Indications for Use:</strong> Intracranial hemorrhage and its
              subtypes, mass effect, midline shift, cranial fracture, hypodensities
              suggesting an Infarct and cerebral atrophy. qERv2.0 EU’s intended use
              includes localization, so overlays are claimed. + qQuant (ICH and subtypes,
              Lateral ventricles, and midline shift)
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qER v2.1
            </div>
            <div>
              <strong>EU Legislation:</strong> MDD
            </div>
            <div>
              <strong>Classification:</strong> Class I
            </div>
            <div>
              <strong>MDD Classification Rule basis of the product claim:</strong> Rule 12
            </div>
            <div>
              <strong>Indications for Use:</strong> Intracranial hemorrhage and its
              subtypes, mass effect, midline shift, cranial fracture, hypodensities
              suggesting an Infarct and cerebral atrophy, ASPECT score
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qCT-Lung v1.0
            </div>
            <div>
              <strong>EU Legislation:</strong> MDD
            </div>
            <div>
              <strong>Classification:</strong> Class I
            </div>
            <div>
              <strong>MDD Classification Rule basis of the product claim:</strong> Rule 12
            </div>
            <div>
              <strong>Indications for Use:</strong> Nodule and Emphysem
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qER- NCCT v1.0
            </div>
            <div>
              <strong>EU Legislation:</strong> MDR
            </div>
            <div>
              <strong>Classification:</strong> Class IIb
            </div>
            <div>
              <strong>MDD Classification Rule basis of the product claim:</strong> Rule 11
            </div>
            <div>
              <strong>Indications for Use:</strong> qERv2.0 (ICH and subtypes, Midline
              Shift, Mass effect, Cranial Fractures) + qQuant (ICH, Lateral ventricles,
              and midline shift)
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qCTv1.0
            </div>
            <div>
              <strong>EU Legislation:</strong> MDR
            </div>
            <div>
              <strong>Classification:</strong> Class IIb
            </div>
            <div>
              <strong>MDD Classification Rule basis of the product claim:</strong> Rule 11
            </div>
            <div>
              <strong>Indications for Use:</strong> Nodule detected based on size, type,
              count, location, and presence of spiculation (type of texture) and
              calcification. Measurement of long axis, short axis diameter and volume of
              nodule.
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qXRv4.0
            </div>
            <div>
              <strong>EU Legislation:</strong> MDR
            </div>
            <div>
              <strong>Classification:</strong> Class IIb
            </div>
            <div>
              <strong>MDD Classification Rule basis of the product claim:</strong> Rule 11
            </div>
            <div>
              <strong>Indications for Use:</strong> Normal, Atelectasis, Blunted
              Costophrenic Angle, Non-Aortic Calcification, Degenerative Spine Conditions,
              Hyperinflation/ Emphysema, Reticulonodular Pattern, Scoliosis, Tracheal
              shift, Elevated Hemidiaphragm, Cardiomegaly, Cavity, Consolidation,
              Fibrosis, Hilar Enlargement, Nodule, Opacity, Pleural Effusion,
              Pneumothorax, Rib Fractures, Lung Nodule Malignancy Score, Radiological
              signs of Tuberculosis & Mass, and measure the distance between the tip of
              the breathing tube (endotracheal or tracheostomy tube) and carina
              (Indications for use 24-25).
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qMSKv1.0
            </div>
            <div>
              <strong>EU Legislation:</strong> MDR
            </div>
            <div>
              <strong>Classification:</strong> Class IIb
            </div>
            <div>
              <strong>MDD Classification Rule basis of the product claim:</strong> Rule 11
            </div>
            <div>
              <strong>Indications for Use:</strong> Ankle, Clavicle, Elbow, Femur,
              Forearm, Hip, Humerus, Knee, Pelvis, Rib, Shoulder, Tibia / Fibula, Wrist,
              Toe, Foot, Finger and Hand
            </div>
          </div>
        </div>
      </div>
      <div>
        <p className="font-semibold text-base md:text-lg">FDA Approved Products</p>
        <table className="hidden md:block table-auto text-sm text-center">
          <thead>
            <tr className="border border-gray-700">
              <th className="border-r border-gray-700 px-4 whitespace-nowrap">
                Product Name
              </th>
              <th className="border-r border-gray-700 px-4">Regulations</th>
              <th className="border-r border-gray-700 px-4 whitespace-nowrap">
                Risk Class
              </th>
              <th className="border-r border-gray-700 px-4">510K number</th>
              <th className="px-4">Tags/Abnormalities</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qER v2.0</td>
              <td className="border-r border-gray-700 px-4">FDA</td>
              <td className="border-r border-gray-700 px-4">Class II</td>
              <td className="border-r border-gray-700 px-4">K200921</td>
              <td className="px-4 text-left">
                Intracranial hemorrhage and its subtypes, mass effect, midline shift,
                cranial fracture.
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qER-quant v1.0</td>
              <td className="border-r border-gray-700 px-4">FDA</td>
              <td className="border-r border-gray-700 px-4">Class II</td>
              <td className="border-r border-gray-700 px-4">K211222</td>
              <td className="px-4 text-left">
                Abnormal Intracranial Hyperdensities, Lateral Ventricles and Midline
                Shift.
              </td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qXR-BT v1.0</td>
              <td className="border-r border-gray-700 px-4">FDA</td>
              <td className="border-r border-gray-700 px-4">Class II</td>
              <td className="border-r border-gray-700 px-4">K212690</td>
              <td className="px-4 text-left">Breathing Tubes</td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qXR-PTX-PE v1.0</td>
              <td className="border-r border-gray-700 px-4">FDA</td>
              <td className="border-r border-gray-700 px-4">Class II</td>
              <td className="border-r border-gray-700 px-4">K230899</td>
              <td className="px-4 text-left">Pneumothorax and Pleural Effusion</td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qXR-CTR v1.0</td>
              <td className="border-r border-gray-700 px-4">FDA</td>
              <td className="border-r border-gray-700 px-4">Class II</td>
              <td className="border-r border-gray-700 px-4">K231149</td>
              <td className="px-4 text-left">CTR (Cardio Thoracic Ratio)</td>
            </tr>
            <tr className="border border-gray-700">
              <td className="border-r border-gray-700 px-4">qXR-LNv1.0</td>
              <td className="border-r border-gray-700 px-4">FDA</td>
              <td className="border-r border-gray-700 px-4">Class II</td>
              <td className="border-r border-gray-700 px-4">K231805</td>
              <td className="px-4 text-left">Nodule</td>
            </tr>
          </tbody>
        </table>
        <div className="border md:hidden border-gray-700 text-sm table-auto">
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qXR-LNv1.0
            </div>
            <div>
              <strong>Regulations:</strong> FDA
            </div>
            <div>
              <strong>Risk Class:</strong> Class II
            </div>
            <div>
              <strong>510K number:</strong> K231805
            </div>
            <div>
              <strong>Tags/Abnormalities:</strong> Nodule
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qXR-CTR v1.0
            </div>
            <div>
              <strong>Regulations:</strong> FDA
            </div>
            <div>
              <strong>Risk Class:</strong> Class II
            </div>
            <div>
              <strong>510K number:</strong> K231149
            </div>
            <div>
              <strong>Tags/Abnormalities:</strong> CTR (Cardio Thoracic Ratio)
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qXR-PTX-PE v1.0
            </div>
            <div>
              <strong>Regulations:</strong> FDA
            </div>
            <div>
              <strong>Risk Class:</strong> Class II
            </div>
            <div>
              <strong>510K number:</strong> K230899
            </div>
            <div>
              <strong>Tags/Abnormalities:</strong> Pneumothorax and Pleural Effusion
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qXR-BT v1.0
            </div>
            <div>
              <strong>Regulations:</strong> FDA
            </div>
            <div>
              <strong>Risk Class:</strong> Class II
            </div>
            <div>
              <strong>510K number:</strong> K212690
            </div>
            <div>
              <strong>Tags/Abnormalities:</strong> Breathing Tubes
            </div>
          </div>
          <div className="border-b border-gray-700 p-4">
            <div>
              <strong>Product Name:</strong> qER-quant v1.0
            </div>
            <div>
              <strong>Regulations:</strong> FDA
            </div>
            <div>
              <strong>Risk Class:</strong> Class II
            </div>
            <div>
              <strong>510K number:</strong> K211222
            </div>
            <div>
              <strong>Tags/Abnormalities:</strong> Abnormal Intracranial Hyperdensities,
              Lateral Ventricles and Midline Shift.
            </div>
          </div>
          <div className="p-4">
            <div>
              <strong>Product Name:</strong> qER v2.0
            </div>
            <div>
              <strong>Regulations:</strong> FDA
            </div>
            <div>
              <strong>Risk Class:</strong> Class II
            </div>
            <div>
              <strong>510K number:</strong> K200921
            </div>
            <div>
              <strong>Tags/Abnormalities:</strong> Intracranial hemorrhage and its
              subtypes, mass effect, midline shift, cranial fracture.
            </div>
          </div>
        </div>
      </div>
      <div>
        <Link
          href="https://www.qure.ai/regulatory-and-privacy"
          target="_blank"
          rel="noreferrer"
        >
          For more information <strong className="underline">click here</strong>.
        </Link>
      </div>
    </div>
  );
};

export default TermsAndConditionsContentStatic;
